<template>
    <div>
        <section class="folders-section section py-5 px-5">
            <p class="px-3 is-size-4 has-text-black">
                <span class="">{{$t('entity_projects')}}</span>
            </p>
            <p class="px-3 is-size-6 has-text-eduloc-grey secondary-font">
                <span class="">{{$t('entity_projects_description')}}</span>
            </p>
        </section>
        
        <section ref="searchBox" class="section pt-5 px-5 pb-6">
            <div class="mx-3">
                <dashboard-app-content-search
                    v-model="textSearch"
                    :availablefilters="filters"
                    :switch-mode="true"
                    :default-switch-mode-name="'LIST_MODE'"
                    @change-filter="changeFilter"
                    @change-project-type="changeProjectType"
                    @change-order="changeOrder"
                    @change-switch-mode="changeMode"
                    :loading="loading"
                    class=""
                />
            </div>
        </section>

        
        <section ref="contentBox" class="section pt-0 px-5" >
            
            <!--<n-dashboard-content
                ref="childComponent"
                :active-filter="selectedFilter"
                :items="projects"
                :loading="loadingItems"
                @delete="removeProject"
                @addProject="addProject"
                :totalProjects="schoolProjectsCount"
                @toggleHighlight="toggleHighlight"
            />-->
            <management-entity-content 
                v-if="filteredProjects.length"
                :projects="filteredProjects"
                :showCreationCard="false" 
                :showMode="showMode"
                @deleteProject="removeProject"
                @addProject="addProject"
            />
            <p
                v-else-if="!loading"
                v-t="'no_content_to_show'"
                class="notification is-eduloc-yellow mx-3"
            ></p>
        </section>
    </div>
</template>

<script>
import { fetchEntityProjects } from '@/services/API';
import DashboardAppContentSearch from '@/components/DashboardAppContentSearch';
import ManagementEntityContent from '@/components/ManagementEntityContent';
import { Document } from 'flexsearch';
import _ from 'underscore';

export default {
    components: {
        DashboardAppContentSearch,
        ManagementEntityContent,   
    },
    data() {
        return {
            content: [],
            loading: false,
            textSearch: "",
            typeSearch: 'PROJECT_TYPE_ALL',
            filterSearch: 'APP_ALL',
            order: 'CREATED_ASC',
            searchIndex: new Document({
                resolution: 3,
                tokenize: 'full',
                document: {
                    id: '_id',
                    index: [
                        {
                            field: 'title',
                            minlength: 0,
                        },
                        'owner:name',
                        'owner:email',
                    ],
                },
            }),
            filters: [
                'APP_ALL',
                'GAME_ACTIVE',
                'GAME_FINISHED'
            ],
            gameTypeProjects: [
                "PROJECT_TYPE_QUIZ",
                "PROJECT_TYPE_QUIZHUNT",
                "PROJECT_TYPE_GEOQUIZ",
                "PROJECT_TYPE_TREASUREHUNT",
                "PROJECT_TYPE_MEMORY"
            ],
            showMode: 'LIST_MODE',





            /*loadingItems: false,
            searchString: this.$route.query.search,
            selectedType: 'FILTER_OPTION_PROJECTS_ALL',
            selectedFilter: this.$route.query.filter || 'mine',
            queryType: this.$route.query.type,
            items: [],
            projects: [],
            featuredProjects: [],
            currentPage: 1,
            limit: 24,
            offset: 0,
            lastPage: false,
            //availableProjectOptions: [this.$t('Constants.FILTER_OPTION_ALL'),this.$t('Constants.FILTER_OPTION_PROJECTS_INVITED'),this.$t('Constants.FILTER_OPTION_PROJECTS_PARTICIPATED')],
            selectedProjectOption: this.$t('Constants.FILTER_OPTION_ALL'),
            filterOptions: this.$t('Constants.FILTER_OPTION_ALL'),
            filters: [],
            formats: undefined,
            updateFolders: false,
            creatingFolder: false,
            searching: false,
            schoolProjectsCount: 0,*/
        };
    },
    computed: {

        textFilteredProjects() {
            // console.log("textSearch",this.textSearch)
            if (this.textSearch) {
                this.rebuildIndex();
                this.content.forEach((item) => {
                    this.searchIndex.add(item);
                });
                const result = this.searchIndex.search(this.textSearch);
                // console.log(this.textSearch, result);
                const ids = _.chain(result).pluck('result').flatten().value();
                // console.log('ids', ids);
                return this.content.filter((item) => {
                    return _.contains(ids, item._id);
                });
            }
            return this.content;
        },
        filteredProjects() {
            // console.log("filtering projects")
            let projects = this.textFilteredProjects;
            let inFilters = [];
            let inType = [];

            if(this.typeSearch){
                if(this.typeSearch!='PROJECT_TYPE_ALL'){
                    inType =
                        _.filter(
                            this.textFilteredProjects,
                            (project) => {
                                if (project.project) {
                                    return project.project.format == this.typeSearch
                                } else {
                                    return project.format == this.typeSearch
                                }
                            }
                        );
                }else{
                    inType = projects;
                }
                
            }

            if (inType.length) {
                projects = _.uniq(_.intersection(projects, inType));
            }else{
                projects = [];
            }


            if(this.filterSearch){
                if(this.filterSearch!='APP_ALL'){
                    inFilters =
                        _.filter(
                            this.textFilteredProjects,
                            (project) => {
                                switch (this.filterSearch) {
                                    case 'GAME_ACTIVE':
                                        return project.activeSession
                                    case 'GAME_FINISHED':
                                        return this.gameTypeProjects.includes(project.format) && !project.activeSession
                                }
                            }
                        );
                }else{
                    inFilters = projects;
                }
                
            }

            if (inFilters.length) {
                projects = _.uniq(_.intersection(projects, inFilters));
            }else{
                projects = [];
            }

            if(this.order){
                let orderedProjects;
                // console.log('ordening',this.order)
                switch(this.order){
                    case 'CREATED_DESC':
                        orderedProjects = _.sortBy(projects, function(o) { 
                            return o.created; 
                            });
                        break;
                    case 'CREATED_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.created; }).reverse();
                        break;
                    case 'MODIFIED_DESC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.modified; });
                        break;
                    case 'MODIFIED_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.modified; }).reverse();
                        break;
                    case 'TITLE_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.title; });
                        break;
                    case 'AUTHOR_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.owner.username; });
                        break;
                    case 'TYPE_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.format; });
                        break;
                    default: 
                        orderedProjects = _.sortBy(projects, function(o) { return o.created; });
                        break;
                }
                projects = orderedProjects;
            }
            return projects;
        },








        /*projectType() {
            if (
                this.selectedType ==
                this.$t('Constants.FILTER_OPTION_PROJECTS_COLLECTIONS')
            ) {
                return 'collection,map';
            } else if (
                this.selectedType ==
                this.$t('Constants.FILTER_OPTION_PROJECTS_GAMES')
            ) {
                return 'trivial,treasurehunt,scape,memory,quizhunt';
            }
            return 'collection,trivial,treasurehunt,storytelling,scape,memory,quizhunt';
        },
        handleDebouncedScroll() {
            return _.debounce(this.handleScroll, 100);
        },
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        showNoProjects(){
            return !this.projects.length && !this.searchString && this.selectedType=='FILTER_OPTION_PROJECTS_ALL'
        }*/
    },
    watch: {
        content: {
            handler: function () {
                this.content.forEach((item) => {
                    this.searchIndex.add(item);
                });
            },
            immediate: true,
            deep: true,
        },




        /*'$route.query.filter': function (newValue) {
            if (newValue) {
                this.selectedFilter = newValue;
            }
        },
        '$route.query.type': function (newValue) {
            this.queryType = newValue;
        },
        '$route.query.search': function (newValue) {
            this.searchString = newValue;
            // console.log('newValue for text search', newValue);
        },
        selectedFilter: {
            handler: 'filterHandler',
            immediate: true,
        },
        searchString: {
            handler: 'searchStringHandler',
            immediate: false,
        },
        selectedType: {
            handler: 'typeHandler',
            immediate: false,
        },
        selectedProjectOption: {
            handler: 'projectOptionHandler',
            immediate: true,
        },
        filters: {
            handler: 'filtersHandler',
            immediate: false,
        },*/
    },
    mounted() {
        window.addEventListener('scroll', this.handleDebouncedScroll, true);

        this.loading = true;
        fetchEntityProjects().then(({ data }) => {
            this.content = data;
            this.loading = false;
        });
        
        
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleDebouncedScroll);
    },
    methods: {
        toggleListed(project) {
            //this.$emit("toggleHighlight",project)
            const updatedIndex = _.findIndex(this.content, {
                _id: project._id,
            });

            this.content.splice(updatedIndex, 1, project);
        },
        changeFilter(e){
            // console.log("change filter",e)
            this.filterSearch=e;
        },
        changeProjectType(e){
            // console.log("change project type",e)
            this.typeSearch=e;
        },
        changeOrder(e){
            // console.log("change order",e)
            this.order=e;
        },
        rebuildIndex() {
            let projects = this.content;
            this.searchIndex.remove(projects);
        },
        changeMode(e) {
            // console.log("change show mode",e)
            this.showMode = e;
        },
        removeProject(_id) {
            // console.log('removing item', _id);
            this.content = _.filter(this.content, (item) => {
                return item._id != _id;
            });
        },
        addProject(project) {
            // console.log('dashboardProjects', project);
            this.content.push(project);
            //this.resetSearch();
        },
        resetSearch() {
            this.content = [];
            this.loading = true;
            fetchEntityProjects().then(({ data }) => {
                this.content = data;
                this.loading = false;
            });
        },
        
        










        /*selectProject(project) {
            this.$refs.childComponent.selectProject(project);
        },
        async getItems() {
            if (this.loadingItems) {
                // another call is running
                return;
            }
            this.loadingItems = true;
            // console.log('offset send', this.offset);
            if (!this.searchString && this.selectedFilter == 'mySchool') {
                let responseFeatured = await fetchItems(
                    `project/${this.selectedFilter}`,
                    {
                        type_in: this.projectType,
                        _offset: 0,
                        _limit: 9999,
                        _featured: true,
                        _sort: 'order:asc',
                    }
                );
                this.featuredProjects = responseFeatured.data;
                let response = await fetchItems(
                    `project/${this.selectedFilter}`,
                    {
                        title_contains: this.searchString,
                        description_contains: this.searchString,
                        owner_contains: this.searchString,
                        type_in: this.projectType,
                        _offset: this.offset,
                        _limit: this.limit,
                    }
                ).finally(() => {
                    this.loadingItems = false;
                    this.$emit('enableLinks');
                });
                // console.log('items length before news', this.items.length);
                this.items = this.items.concat(response.data);
                this.offset = this.items.length;
                // console.log('new offset to send ', this.offset);
                if (response.data.length < this.limit) {
                    this.lastPage = true;
                }
                this.projects = this.items.filter((item) => {
                    if (!item.featured) {
                        return item;
                    }
                });
            } else {
                // console.log('call in process');
                let response = await fetchItems(
                    `project/${this.selectedFilter}`,
                    {
                        title_contains: this.searchString,
                        description_contains: this.searchString,
                        owner_contains: this.searchString,
                        type_in: this.projectType,
                        format_in: this.formats,
                        _offset: this.offset,
                        _limit: this.limit,
                    }
                ).finally(() => {
                    this.loadingItems = false;
                    this.$emit('enableLinks');
                });
                this.items = this.items.concat(response.data);
                this.offset = this.items.length;
                if (response.data.length < this.limit) {
                    this.lastPage = true;
                }
                this.projects = this.items;
                if (
                    this.selectedProjectOption !=
                        this.$t('Constants.FILTER_OPTION_ALL') &&
                    this.selectedFilter == 'invited'
                ) {
                    this.projectOptionHandler();
                }
            }
            this.searching=false;
        },
        async removeProject(_id) {
            // console.log('removing item', _id);
            this.items = _.filter(this.items, (item) => {
                return item._id != _id;
            });
            if (this.projects.length > 0) {
                this.projects = _.filter(this.projects, (project) => {
                    return project._id != _id;
                });
            }
        },
        
        filterHandler() {
            // console.log('in filter handler', this.selectedFilter);
            this.projects = [];
            this.items = [];
            this.offset = 0;
            this.lastPage = false;
            this.$emit('disableLinks');
            let query = Object.assign({}, this.$route.query);
            this.$router
                .push({
                    query: { ...query, ...{ filter: this.selectedFilter } },
                })
                .catch((e) => {
                    console.log('error selected filter');
                });
            this.resetSearch();
        },
        typeHandler() {
            this.searching = true;
            if (this.selectedType == 'FILTER_OPTION_ALL') {
                this.formats = undefined;
            } else {
                this.formats = this.selectedType;
            }
            this.projects = [];
            this.items = [];
            this.offset = 0;
            this.lastPage = false;
            this.resetSearch();
        },
        searchStringHandler() {
            // console.log('searching', this.searchString);
            if (this.searchString && this.searchString.length == 0) {
                this.searchString = undefined;
            }
            // console.log('send', this.searchString);
            let query = Object.assign({}, this.$route.query);
            this.$router
                .push({
                    query: { ...query, ...{ search: this.searchString } },
                })
                .catch(() => {
                    console.log('error selected string');
                });
            this.resetSearch();
        },
        filtersHandler() {
            // console.log('filters', this.filters);
            this.projects = [];
            this.items = [];
            this.offset = 0;
            this.lastPage = false;
            this.$emit('disableLinks');
            if (this.filters.length < 1) {
                this.formats = undefined;
            } else {
                this.formats = this.filters.join();
            }
            this.resetSearch();
        },
        resetSearch() {
            this.offset = 0;
            this.lastPage = false;
            this.items = [];
            this.getItems();
        },
        handleScroll() {
            const { scrollHeight, clientHeight, scrollTop } =
                document.documentElement;
            const bottomOfWindow =
                (scrollHeight - 300 >= clientHeight + scrollTop) /
                    scrollHeight ==
                0;
            if (bottomOfWindow && !this.lastPage) {
                this.getItems();
            }
        },
        projectOptionHandler() {
            switch (this.selectedProjectOption) {
                case this.$t('Constants.FILTER_OPTION_ALL'):
                    this.projects = this.items;
                    break;
                case this.$t('Constants.FILTER_OPTION_PROJECTS_PARTICIPATED'):
                    this.projects = this.items.filter((item) => {
                        if (item.watching === true) {
                            return item;
                        }
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_PROJECTS_INVITED'):
                    this.projects = this.items.filter((item) => {
                        if (item.watching === false) {
                            return item;
                        }
                    });
                    break;
            }
        },
        addProject() {
            console.log('dashboardProjects');
            this.resetSearch();
        },
        createFolder() {
            console.log('creating folder');
            this.creatingFolder = true;
        },
        folderCreated() {
            console.log('folder created');
            this.creatingFolder = false;
            this.$emit("folderCreated");
        },
        folderUpdated() {
            this.$emit("folderUpdated");
        },
        projectFilter(e){
            // console.log(e)
            this.selectedType=e;
        },
        toggleHighlight(project) {
            const updatedIndex = _.findIndex(this.items, {
                _id: project._id,
            });

            this.items.splice(updatedIndex, 1, project);
            // this.publicProjects.splice(updatedIndex, 1);
        }*/
    },
};
</script>

<style scoped>
.hide {
    visibility: hidden !important;
    height: 0px;
    width: 0px;
    overflow: hidden;
}
.show {
    height: auto;
    overflow: hidden;
}
.is-horizontally-centered {
    margin: 0 auto;
}
.lb-creation-object .icon.is-large {
    height: 10rem;
    width: 10rem;
}
.mdi-10r {
    font-size: 10rem;
}

.back-image{
    padding-top: 5rem;
    max-width: 45%;
}
</style>
